// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"48de0065","726":"963a3013"}[chunkId] + ".chunk.js";
};